import tippy from "tippy.js";

(function($) {
    $(document).gp_ready(function(){
        tippy('[data-tooltip]', {
            content: (reference) => reference.getAttribute('data-tooltip'),
            theme: 'greenbutik',
            placement: 'top-start',
            duration: [200, 200],
        });
    })
})(jQuery);